/**
 * @description Is the current window location path an internal page?
 */
const isInternalRoute = ({ location }: typeof window = window) => {
  const [_, path] = location.pathname.split("/");
  return path === "internal";
};

export default isInternalRoute;
